import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgImages = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.625 4.375H7.875a1.75 1.75 0 0 0-1.75 1.75v1.75h-1.75a1.75 1.75 0 0 0-1.75 1.75v12.25a1.75 1.75 0 0 0 1.75 1.75h15.75a1.75 1.75 0 0 0 1.75-1.75v-1.75h1.75a1.75 1.75 0 0 0 1.75-1.75V6.125a1.75 1.75 0 0 0-1.75-1.75Zm-15.75 1.75h15.75v6.863l-1.101-1.1a1.75 1.75 0 0 0-2.476 0l-2.187 2.188-4.813-4.813a1.75 1.75 0 0 0-2.474 0l-2.699 2.7V6.124Zm12.25 15.75H4.375V9.625h1.75v8.75a1.75 1.75 0 0 0 1.75 1.75h12.25v1.75Zm3.5-3.5H7.875v-3.938l3.938-3.937 5.431 5.432a.875.875 0 0 0 1.237 0l2.807-2.807 2.337 2.338v2.912ZM17.5 9.187a1.313 1.313 0 1 1 2.625 0 1.313 1.313 0 0 1-2.625 0Z" />
  </svg>
);
export default SvgImages;
